import { EPhysicsCtx } from '../node_modules/@nxg-org/mineflayer-physics-util/src/physics/settings';
import { PhysicsUtilWrapper } from '../node_modules/@nxg-org/mineflayer-physics-util/src/wrapper';
export default function loader(bot) {
    if (!bot.physicsUtil) {
        initSetup(bot.registry);
        bot.physicsUtil = new PhysicsUtilWrapper(bot);
    }
}
export function initSetup(data) {
    EPhysicsCtx.loadData(data);
}
export { PhysicsUtilWrapper } from '../node_modules/@nxg-org/mineflayer-physics-util/src/wrapper';
export { EPhysicsCtx, PhysicsWorldSettings } from '../node_modules/@nxg-org/mineflayer-physics-util/src/physics/settings';
export { BaseSimulator } from '../node_modules/@nxg-org/mineflayer-physics-util/src/simulators';
export { EntityPhysics, BotcraftPhysics, BoatPhysics, HorsePhysics } from '../node_modules/@nxg-org/mineflayer-physics-util/src/physics/engines';
export { EntityState, PlayerState, PlayerPoses, BoatState, BoatStatus, HorseState } from '../node_modules/@nxg-org/mineflayer-physics-util/src/physics/states';
export { ControlStateHandler } from '../node_modules/@nxg-org/mineflayer-physics-util/src/physics/player';
export { convertPlayerState, applyToPlayerState } from '../node_modules/@nxg-org/mineflayer-physics-util/src/util/physicsUtils';
